import { useApi } from 'hooks/useApi';
import { useStoreUtils } from 'hooks/useStoreUtils';
import React, { useEffect, useState } from 'react';
import SynthesesTable from 'views/homeCompta/SynthesesTable';

const MySyntheses = () => {
	const { getUserSyntheses } = useApi()
	const { state: { user } } = useStoreUtils()
	const [syntheses, setSyntheses] = useState([])

	useEffect(() => {
		getUserSyntheses(user.id)
			.then(setSyntheses)
			.catch(e => console.log(e))
	}, [getUserSyntheses, user])

	return (
		<SynthesesTable syntheses={syntheses} title='Mes synthèses' />
	);
};

export default MySyntheses;